export const iconStytle = {
  mr: 2,
  width: 20,
  height: 20,
  '@media (min-width: 600px)': {
    mr: 1.5,
    width: 16,
    height: 16,
  },
};
